/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricemustbepositive3Inputs */

const en_pricemustbepositive3 = /** @type {(inputs: Pricemustbepositive3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price must be positive`)
};

const de_pricemustbepositive3 = /** @type {(inputs: Pricemustbepositive3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preis muss positiv sein`)
};

/**
* | output |
* | --- |
* | "Price must be positive" |
*
* @param {Pricemustbepositive3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const pricemustbepositive3 = /** @type {((inputs?: Pricemustbepositive3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricemustbepositive3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricemustbepositive3(inputs)
	return de_pricemustbepositive3(inputs)
});
export { pricemustbepositive3 as "priceMustBePositive" }